export default __webpack_public_path__ + "img/autocomplete-icons_hdpi.d1a52ad392d26179816171344b3a282f.png";